import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=863795de&scoped=true"
import script from "./ClientInformation.vue?vue&type=script&lang=js"
export * from "./ClientInformation.vue?vue&type=script&lang=js"
import style0 from "./ClientInformation.vue?vue&type=style&index=0&id=863795de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863795de",
  null
  
)

export default component.exports